import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

interface CustomButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'link' |
            'outline-primary' | 'outline-secondary' | 'outline-success' | 'outline-danger' | 'outline-warning' |
            'outline-info' | 'outline-light' | 'outline-dark';
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  className?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  type?: 'button' | 'submit' | 'reset'; // Only valid button types here
  to?: string; // If provided, renders a <Link>
  asLink?: boolean; // Custom prop to trigger <Link> rendering
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = '',
  onClick,
  type = 'button',
  to = '',
  asLink = false,
  ...props
}) => {
  const classes = clsx(
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    { disabled },
    className
  );

  if (asLink && to) {
    return (
      <Link
        to={to}
        onClick={(e) => {
          if (disabled) e.preventDefault();
          if (!disabled && onClick) onClick(e);
        }}
        className={classes}
        {...props}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default CustomButton;
